import { render, staticRenderFns } from "./ComponentTestView.vue?vue&type=template&id=dc69c330&"
import script from "./ComponentTestView.vue?vue&type=script&lang=js&"
export * from "./ComponentTestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports